module.exports = __webpack_public_path__ + "static/media/voltgroom-1.b04034b8.jpg";